import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { select, Store } from '@ngxs/store';
import { AnimateModule, PaginatorComponent, UserType, WwwAppState, WwwRouteSlug } from '@pro-connect/shared';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskPipe } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { IOrder } from '../../models/order';
import { MyDataState, MyDataStateGetClientOrders } from '../../my-data.state';
import { OrderDetailsModalComponent } from './components/order-details-modal/order-details-modal.component';

export type FilterFormType = {
  dateFrom: FormControl<string | null>;
  dateTo: FormControl<string | null>;
  type: FormControl<string | null>;
};
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    AnimateModule,
    ReactiveFormsModule,
    FormsModule,
    NgxsFormPluginModule,
    BsDatepickerModule,
    NgSelectModule,
    PaginatorComponent,
    NgxMaskPipe,
  ],
})
export class PaymentHistoryComponent implements OnInit {
  private readonly _ngbModal: NgbModal = inject(NgbModal);
  protected readonly _store: Store = inject(Store);
  protected readonly _toastService: ToastrService = inject(ToastrService);

  public readonly loading = select(MyDataState.loading);
  public readonly orders = select(MyDataState.paymentHistory);
  public readonly user = select(WwwAppState.user);
  public readonly WwwRouteSlug = WwwRouteSlug;
  public readonly formGroup: FormGroup<FilterFormType>;
  public readonly UserType = UserType;
  public model = null;

  constructor(private readonly _formBuilder: FormBuilder) {
    this.formGroup = this._formBuilder.group({
      dateFrom: new FormControl<string | null>(null),
      dateTo: new FormControl<string | null>(null, []),
      type: new FormControl<string | null>(null, []),
    });
  }

  public ngOnInit(): void {
    this._store.dispatch([new MyDataStateGetClientOrders()]);
  }

  get f() {
    return this.formGroup.controls;
  }

  public showCommunicat(text: string): void {
    this._toastService.warning(text);
  }

  public pageChange(event: { page: number }): void {
    this._store.dispatch([
      new MyDataStateGetClientOrders({
        listDto: { page: event.page },
      }),
    ]);
  }

  public openOrderDetailsModal(order: IOrder): void {
    const ngbModalRef = this._ngbModal.open(OrderDetailsModalComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static',
      modalDialogClass: 'modal-sm-container',
    });
    ngbModalRef.componentInstance.order = signal(order);
  }
}
